"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSelector = void 0;

var createSelector = function createSelector() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return function (state) {
    return [state].concat(selectors).reduce(function (a, b) {
      return b(a);
    });
  };
};

exports.createSelector = createSelector;
//# sourceMappingURL=utils.js.map